<template>
  <div class="manage_page fillcontain">
    <el-row style="height: 100%;">
      <el-col :span="4"  style="min-height: 100%; background-color: #495965;">
        <!--:default-openeds="['1','2','3','4']"-->
        <el-menu :default-active="defaultActive"  style="min-height: 100%;" class="title-menu" theme="dark" router>
          <el-menu-item index="/"><p :style="{'text-align' : 'center','font-weight':'bold','font-size': groupNameFontSize}">{{groupName}}</p></el-menu-item>
<!--          <el-menu-item index="index"><img src="../../assets/koolearn.png" style="width: 100px"></el-menu-item>-->
          <el-submenu v-for="(item, i) in menuData" :index="(i+1).toString() " >
            <template slot="title"><i v-bind:class="formatMenuTitleLeftIcon(i)"></i><span  style="color: #FFFFFF">{{item.label}}</span></template>
            <el-menu-item v-for="subItem in item.subMenus" :index="subItem.path" class="sub-menu" >{{subItem.label}}</el-menu-item>
          </el-submenu>
        </el-menu>
      </el-col>
      <el-col :span="20" style="height: 100%;overflow: auto;">
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'Index',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      menuData: [],
      groupName: '首页',
      groupNameFontSize: '12px'
    }
  },
  created () {
    this.getCurGroupName()
    this.getMenuData()
  },
  methods: {
    getCurGroupName () {
      this.$api.home.getCurGroupNameData().then((res) => {
        if (res.code === 0) {
          this.groupName = res.data.name
          // this.groupName = '北京知行云课股份有限公司'
          this.getGroupNameFontSize()
        }
      })
    },
    getMenuData () {
      this.$api.home.getAdminMenuData().then((res) => {
        if (res.code === 0) {
          // let menuDataStr = '[{"label":"用户管理","subMenus":[{"label":"子管理员","path":"adminop"},{"label":"老师","path":"teacherop"},{"label":"助教","path":"assistantop"}]},{"label":"课程直播管理","subMenus":[{"label":"课程管理","path":"courseop"}]}]'
          // this.menuData = JSON.parse(menuDataStr)
          this.menuData = res.data
          console.log('menuData:', this.menuData)
          // debugger
        } else {
          this.$router.replace('/login')
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    getGroupNameFontSize () {
      if(this.groupName.length < 5) {
        this.groupNameFontSize = '18px'
      } else if(this.groupName.length < 10) {
        this.groupNameFontSize = '14px'
      }else {
        this.groupNameFontSize = '12px'
      }

    },
    formatMenuTitleLeftIcon (index) {
      if (index === 0){
        return 'el-icon-s-order'
      } else if (index === 1){
        return 'el-icon-s-custom'
      } else if (index === 2){
        return 'el-icon-reading'
      } else if (index === 3){
        return 'el-icon-upload'
      } else if (index === 4){
        return 'el-icon-chat-line-round'
      } else {
        return 'el-icon-document'
      }
    },
    formatMenuList (data) {
      let resultList = []
      for (let key in data) {
        // console.log('menuKey:', key)
        let itemArray = key.split('-')
        if (itemArray.length > 1) {
          let menuItem = {index: itemArray[0], label: itemArray[1]}
          let subMenuObj = data[key]
          // console.log('subMenu:', subMenuObj)
          let subMenuList = []
          for (let subMenuKey in subMenuObj) {
            let subMenuKeyStrArray = subMenuKey.split('-')
            if (subMenuKeyStrArray.length > 1) {
              let subMenuItem = {index: subMenuKeyStrArray[0], label: subMenuObj[subMenuKey], path: subMenuKeyStrArray[1]}
              subMenuList.push(subMenuItem)
            }
          }
          menuItem.subMenu = subMenuList
          resultList.push(menuItem)
        }
      }
      return resultList
    }
  },
  computed: {
    defaultActive: function (data) {
      return this.$route.path.replace('/', '')
    }
  }

}
</script>

<style lang="less" scoped>
  @import '../../style/mixin-bak';
  .manage_page{

  }
  .el-menu-item{
    background-color: #34434e;
    color: #FFFFFF;
  }
  .el-menu-item:hover{
    outline: 0 !important;
    color: #ffffff !important;
    background: #3190e8 !important;
  }
  .el-menu-item.is-active {
    color: #5DC0BA !important;
    background: #34434e !important;
  }
  .el-menu{
    background-color: #495965;
    color: #FFFFFF;
  }
  .el-submenu__title:focus, .el-submenu__title:hover {
    outline: 0 !important;
    color: #409EFF !important;
    background: none !important;
  }

</style>



// WEBPACK FOOTER //
// src/page/index/Index.vue